export enum MaintenanceColumnKeys {
  ICON = 'icon',
  NAME = 'maintenanceName',
  CATEGORY = 'maintenanceCategory',
  TYPE = 'maintenanceTypeName',
  EQUIPMENT = 'equipmentName',
  EQUIPMENT_CUSTOMER_SERIAL_NUMBER = 'equipmentCustomerSerialNumber',
  DUE_DATE = 'dueDateInfo.dueDate',
  DUE_OPERATING_HOURS = 'dueAtOperatingHours',
  REMAINING_TIME = 'dueDateInfo.remainingValue',
  WARNING_LEVEL = 'dueDateInfo.warningLevel',
  CURRENT_LOCATION_NAME = 'currentLocationName',
  CURRENT_LOCATION_NUMBER = 'currentLocationNumber',
  CURRENT_LOCATION_COST_CENTER = 'currentLocationCostCenter',
  EQUIPMENT_TYPE_CATEGORY2 = 'equipmentType.category2',
  EQUIPMENT_IMAGE = 'equipmentImage',
  EQUIPMENT_SERIAL_NUMBER = 'equipmentSerialNumber',
  EQUIPMENT_LABELS = 'equipmentLabels',
  EQUIPMENT_MODEL = 'equipmentModel',
  EQUIPMENT_MANUFACTURER_NAME = 'equipmentManufacturerName',
  CURRENT_ADDRESS = 'currentAddress',
  STATUS = 'status',
  EQUIPMENT_BEUTLHAUSER_ID = 'equipmentBeutlhauserId',
  EQUIPMENT_COST_CENTER = 'equipmentCostCenter',
  EQUIPMENT_CONSTRUCTION_YEAR = 'equipmentConstructionYear',
  CURRENT_OPERATING_HOURS = 'currentOperatingHours',
  ORGANISATION = 'organisationName',
  PROJECT = 'projectName',
  EQUIPMENT_SCAN_CODE = 'equipmentScanCode',
  EQUIPMENT_BGL_CODE = 'equipmentBGLCode',
  EQUIPMENT_LICENSE_PLATE = 'equipmentLicensePlate',
  EQUIPMENT_REGISTRATION_DATE = 'equipmentRegistrationDate',
  ASSIGNED_OWNER = 'assignedOwner',
  ASSIGNED_PERSON_IN_CHARGE = 'assignedPersonInCharge',
  ASSIGNED_MAINTENANCE_ASSIGNEE = 'assignedMaintenanceAssignee',
  ASSIGNED_DRIVER = 'assignedDriver',
  ASSIGNED_POSSESSOR = 'assignedPossessor',
  TELEMATIC = 'telematic',
  TELEMATIC_LOCATION = 'liveAddress',
  ACTIONS = 'openActions',
  CUSTOMER_NAME = 'customerName',
}
